var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7381 23.75H23.75M23.7381 23.75C22.9598 24.5219 21.5492 24.3296 20.5599 24.3296C19.3456 24.3296 18.7609 24.5672 17.8943 25.4338C17.1564 26.1717 16.1672 27.5 15 27.5C13.8329 27.5 12.8437 26.1717 12.1057 25.4338C11.2391 24.5672 10.6544 24.3296 9.44008 24.3296C8.45085 24.3296 7.04023 24.5219 6.26186 23.75C5.47726 22.972 5.67035 21.5555 5.67035 20.5599C5.67035 19.3018 5.3952 18.7232 4.49922 17.8273C3.16642 16.4945 2.50002 15.8281 2.5 15C2.50001 14.1719 3.1664 13.5055 4.49919 12.1727C5.299 11.3729 5.67035 10.5803 5.67035 9.44007C5.67035 8.45082 5.47812 7.04018 6.25 6.26181C7.02803 5.47723 8.4445 5.67032 9.4401 5.67032C10.5803 5.67032 11.3729 5.299 12.1727 4.49921C13.5055 3.1664 14.1719 2.5 15 2.5C15.8281 2.5 16.4945 3.1664 17.8273 4.49921C18.6269 5.29883 19.4193 5.67032 20.5599 5.67032C21.5492 5.67032 22.9598 5.47809 23.7382 6.25C24.5227 7.02804 24.3297 8.44449 24.3297 9.44007C24.3297 10.6982 24.6048 11.2767 25.5008 12.1727C26.8336 13.5055 27.5 14.1719 27.5 15C27.5 15.8281 26.8336 16.4945 25.5008 17.8273C24.6048 18.7232 24.3297 19.3018 24.3297 20.5599C24.3297 21.5555 24.5227 22.972 23.7381 23.75Z",
    stroke: "#676767",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 16.1161L13.5 18.125L18.75 11.875",
    stroke: "#676767",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeals);
export default __webpack_public_path__ + "static/media/Deals.7f6d923c23db95b6bd7813f47ef5fdf4.svg";
export { ForwardRef as ReactComponent };